<template>
  <div class="snap-nav-wrap">
    <slot name="before" />
    <ul
      ref="nav"
      class="snap-nav"
    >
      <slot />

      <li
        v-if="inkbar && activeIndex !== -1"
        class="snap-ink-bar"
        :class="{
          trans: readyTrans
        }"
        :style="barStyle"
      />
    </ul>
    <slot name="after" />
  </div>
</template>

<script>
import { scollToCenter } from './setCenter.js'

const isSupportTouch = 'ontouchend' in window

export default {
  name: 'VSnapNav',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 每次选择是否自动居中
    isCenter: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Number, String],
      default: 0
    },
    // 允许找不到值
    accpetNone: {
      type: Boolean,
      default: false
    },
    // 是否启用 bar 动画
    animated: {
      type: Boolean,
      default: false
    },
    // 是否显示选中状态下划线
    inkbar: {
      type: Boolean,
      default: false
    },
    barHeight: {
      type: String,
      default: '2px'
    },
    styleBar: {
      type: Object,
      default: () => ({})
    },
    // 固定 bar width
    forceBarWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      readyTrans: false,
      onceLoad: false,
      barWidth: this.forceBarWidth,
      barOffset: 0,
      xchildren: []
    }
  },
  computed: {
    activeIndex() {
      const { xchildren, value } = this
      if (!xchildren || xchildren.length === 0 || !value) return 0
      const index = this.xchildren.findIndex((current, index) => current.name === value || index === value)
      if (index === -1) {
        return this.accpetNone ? -1 : 0
      }
      return index
    },
    barStyle() {
      if (this.activeIndex === -1) {
        return {}
      }
      const style = {
        visibility: 'visible',
        width: `${this.barWidth}px`,
        height: this.barHeight,
        ...this.styleBar
      }
      if (this.animated) {
        const transform = `translate3d(${this.barOffset}px, 0px, 0px)`
        style.transform = transform
        style.webkitTransform = transform
      } else {
        style.left = `${this.barOffset}px`
      }
      return style
    },
    lastNameStr() {
      return this.xchildren.reduce((str, x) => {
        str += x.name
        return str
      }, '')
    }
  },
  watch: {
    activeIndex(val, oldVal) {
      this.updateWithActiveIndex(val, oldVal)
      if (val !== -1) {
        if (this.isCenter && this.xchildren[val]) {
          this.$nextTick(() => {
            scollToCenter(this.xchildren[val].$el, !this.onceLoad, this.$refs.nav)
            if (!this.onceLoad) {
              this.onceLoad = true
            }
          })
        }
      } else {
        this.barOffset = 0
        this.onceLoad = false
        this.readyTrans = false
      }
    }
  },
  mounted() {
    // 获取所有的child
    this.xchildren = this.getChild()
    this.updateWithActiveIndex(this.activeIndex)

    this.$on('changeItem', (item) => {
      this.$emit('change', item.name)
    })

    window.addEventListener('resize', this.updateBar)

    if (!isSupportTouch) {
      this.patchDesktopScroll()
    }
  },
  beforeDestory() {
    window.removeEventListener('resize', this.updateBar)
    this.$off('changeItem')

    if (!isSupportTouch) {
      this.$refs.nav.removeEventListener('mousedown', this.onMousedown, false)
      document.removeEventListener('mouseup', this.onMouseup, false)
      document.removeEventListener('mousemove', this.onMousemove, false)
    }
  },
  activated() {
    if (this.activeIndex > 0) {
      scollToCenter(this.xchildren[this.activeIndex].$el, true, this.$refs.nav)
    }
    this.updateWithActiveIndex(this.activeIndex)
  },
  updated() {
    const child = this.getChild()
    const newNameStr = child.reduce((str, x) => {
      str += x.name
      return str
    }, '')
    // 子节点数量发生变化, 或者子节点 name 发生变化
    if ((child.length !== 0 && child.length !== this.xchildren.length) || newNameStr !== this.lastNameStr) {
      this.updateChild()
    }
  },
  methods: {
    // 给子组件调用
    updateChild() {
      this.xchildren = this.getChild()
    },
    getChild() {
      return this.$children.filter((child) => child.$options.name && child.$options.name === 'VSnapNavItem').sort((a, b) => a.order - b.order)
    },
    updateBar() {
      if (this.activeIndex === -1) return
      this.$nextTick(() => {
        if (!this.$refs.nav) return
        const navItem = this.$refs.nav.querySelector('.snap-nav-item.active .item-label')
        if (!navItem) return
        const { offsetWidth, offsetLeft } = navItem
        if (this.forceBarWidth === 0) {
          this.barWidth = offsetWidth || 0
        }

        const { barWidth } = this
        const diffWidth = (offsetWidth - barWidth) / 2 || 0
        this.barOffset = offsetLeft + diffWidth

        if (!this.readyTrans) {
          clearTimeout(this._timer)
          this._timer = setTimeout(() => {
            this.readyTrans = true
          }, 300)
        }
      })
    },
    updateWithActiveIndex(val, oldVal) {
      const cur = this.xchildren[val]
      const old = this.xchildren[oldVal]
      // 修改 active child
      if (cur) {
        cur.setActive(true)
      }
      if (old) {
        old.setActive(false)
      }
      this.updateBar()
    },
    onMousedown(e) {
      const { pageX } = e
      this.__pointX = pageX
      document.addEventListener('mousemove', this.onMousemove, false)
    },
    onMousemove(e) {
      const { pageX } = e
      const deltaX = pageX - this.__pointX
      this.__pointX = pageX
      const newX = this._scrollElement.scrollLeft - deltaX
      if (newX >= 0 && newX <= this._maxScrollWidth) {
        this._scrollElement.scrollLeft -= deltaX
      }
    },
    onMouseup() {
      document.removeEventListener('mousemove', this.onMousemove, false)
    },
    patchDesktopScroll() {
      const scrollElement = this.$refs.nav
      const { scrollWidth, offsetWidth } = scrollElement
      if (scrollWidth <= offsetWidth) return
      this._scrollElement = scrollElement
      this._maxScrollWidth = scrollWidth
      scrollElement.addEventListener('mousedown', this.onMousedown, false)
      document.addEventListener('mouseup', this.onMouseup, false)
    }
  }
}
</script>

<style lang="less">
.snap-nav-wrap {
  overflow: hidden;

  .snap-nav {
    position: relative;
    display: flex;
    min-width: 100%;
    padding: 0;
    font-size: 0;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    user-select: none;
    white-space: nowrap;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    &.flex {
      display: flex;
      flex-wrap: nowrap;
      // flex 为1的情况下会自动缩放，这个时候总宽度计算会有问题，因为一放大，
      // 所有子元素都会自动放大- 如果要用flex为1，确保没有滚动条，即所有项目撑满，这样比较合理
      li {
        flex: 0 1 auto;
      }
    }
  }
}

.snap-ink-bar {
  position: absolute;
  bottom: 0;
  height: 2px;
  padding: 0;
  border-radius: 2px;
  background: linear-gradient(136.05deg, #ffcb00 0%, rgba(255, 203, 0, 27%) 100%);

  &.trans {
    transition: all 0.3s ease;
  }
}
</style>
